import { isSvelteStore } from "../Utils.js";
import { mount, unmount } from "svelte";
import Tooltip from "./Tooltip.svelte";
export const tooltip = (element, options) => {
    let title;
    let tooltipComponent;
    // eslint-disable-next-line prefer-const
    let props = $state({ title: "" });
    if ((!element.getAttribute("title") || element.getAttribute("title")?.length === 0) && !options?.title) {
        return;
    }
    const mouseEnter = (event) => {
        title = options?.title || element.getAttribute("title");
        element.removeAttribute("title");
        props.visible = true;
        props.title = title || "";
        props.variant = options?.variant;
        props.x = event.pageX;
        props.y = event.pageY;
        if (!tooltipComponent) {
            tooltipComponent = mount(Tooltip, {
                target: document.body,
                props
            });
        }
    };
    const mouseMove = (event) => {
        props.x = event.pageX;
        props.y = event.pageY;
    };
    const mouseLeave = () => {
        if (title && !isSvelteStore(title)) {
            element.setAttribute("title", title);
        }
        props.visible = false;
    };
    element.addEventListener("mouseenter", mouseEnter);
    element.addEventListener("mouseleave", mouseLeave);
    element.addEventListener("mousemove", mouseMove);
    return {
        destroy() {
            element.removeEventListener("mouseenter", mouseEnter);
            element.removeEventListener("mouseleave", mouseLeave);
            element.removeEventListener("mousemove", mouseMove);
            if (tooltipComponent)
                unmount(tooltipComponent);
        }
    };
};
